/* eslint-disable */
export default {
  toolTip: 'Visualizza in {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
